import { UseFormReturn } from "react-hook-form";
import { Input } from "@/components/ui/input";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { OfferFormData } from "./_schema";

interface Props {
    form: UseFormReturn<OfferFormData>;
}

export function OfferProAForm({ form }: Props) {
    const handleEmailChange = (value: string) => {
        form.setValue("candidate.email", value.replace(/\s/g, ""));
    };

    return (
        <div className="space-y-4">
            <div className="mb-8 grid w-full grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
                <FormField
                    control={form.control}
                    name="candidate.first_name"
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel required>Prénom</FormLabel>
                            <FormControl>
                                <Input {...field} value={field.value} required />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="candidate.last_name"
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel required>Nom</FormLabel>
                            <FormControl>
                                <Input {...field} value={field.value} required />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="candidate.email"
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel required>Email</FormLabel>
                            <FormControl>
                                <Input {...field} value={field.value} onChange={e => handleEmailChange(e.target.value)} required />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="candidate.phone"
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel required>Téléphone</FormLabel>
                            <FormControl>
                                <Input {...field} value={field.value} required />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    )}
                />
            </div>
            <div className="grid w-full grid-cols-1 gap-4 sm:grid-cols-2">
                <FormField
                    control={form.control}
                    name="current_job.title"
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel>Emploi occupé</FormLabel>
                            <FormControl>
                                <Input {...field} value={field.value} />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="current_job.starting_date"
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel>Date de début de l'emploi</FormLabel>
                            <FormControl>
                                <Input {...field} value={field.value} placeholder="JJ/MM/YYYY" />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="current_job.classification"
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel>Classification de l'emploi</FormLabel>
                            <FormControl>
                                <Input {...field} value={field.value} />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    )}
                />

                <div className="flex w-full items-stretch gap-4">
                    <FormField
                        control={form.control}
                        name="current_job.level"
                        render={({ field }) => (
                            <FormItem className="w-full md:w-1/2">
                                <FormLabel>Niveau</FormLabel>
                                <FormControl>
                                    <Input {...field} value={field.value} />
                                </FormControl>
                                <FormMessage />
                            </FormItem>
                        )}
                    />
                    <FormField
                        control={form.control}
                        name="current_job.hierarchical_coefficient"
                        render={({ field }) => (
                            <FormItem className="w-full md:w-1/2">
                                <FormLabel>Coef. hiérarchique</FormLabel>
                                <FormControl>
                                    <Input {...field} value={field.value} />
                                </FormControl>
                                <FormMessage />
                            </FormItem>
                        )}
                    />
                </div>
            </div>
        </div>
    );
}
